import { render, staticRenderFns } from "./AddRoundTournament.vue?vue&type=template&id=1b795d2b"
import script from "./AddRoundTournament.vue?vue&type=script&lang=js"
export * from "./AddRoundTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports